/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  snackbar: {
    show: false,
    hover: false,
    action: 'update',
    response: {},
    project_id: -1,
    tworkstep_id: -1,
    conditions: [],
  },
  error: {}

});

// State object
const state = initialState();
// Getter functions
const getters = {

};
// Actions
const actions = {
  applySnackbar({commit, state, rootState}) {
    return new Promise((resolve, reject) => {
      //add/remove elements
      if (['add', 'remove'].includes(state.snackbar.action)) {
        let data = {
          tworksteps: [],
          updates: []
        };
        state.snackbar.response.taktareas.forEach(taktarea => {
            taktarea.tworksteps.forEach(step_id => {
              if (taktarea.elements.length !== 0) {
                data.tworksteps.push(step_id);
                data.updates.push({
                  [`${state.snackbar.action}#elements`]: taktarea.elements
                });
              }
            });
        });
        data.edit_key = rootState.Project.edit_key;
        axios({
          url: `projects/${state.snackbar.project_id}/trains/0/taktareas/0/twaggons/0/tworkpackages/0/tworksteps/0/updatebulk`,
          method: 'PUT',
          data: data
        })
        .then(() => {
          data.bulk = {
            parent_type: 'tworksteps',
            target_type: 'elements'
          };
          data.action = state.snackbar.action;
          data.bidirectional = true;
          commit('Ultra/update_u_object_relations', {rootState, payload: data}, {root: true});
          commit('update_snackbar', {show: false});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
      }
    });
  },
  requestSnackbarUpdateRelations({commit}, payload) {
    return new Promise((resolve) => {
      axios({
        url: 'projects/' + payload.project_id + '/snackbarbimprocess',
        method: 'POST',
        data: {
          tworkstep: payload.tworkstep,
          conditions: payload.conditions
        },
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        let snackbar_payload = {
          show: true,
          action: payload.action,
          response: resp.data.data,
          project_id: payload.project_id,
          tworkstep_id: payload.tworkstep,
          conditions: payload.conditions,
        };
        commit('update_snackbar', snackbar_payload);
        resolve();
    });
    });
  },
  updateSnackbar({commit}, payload) {
    commit('update_snackbar', payload);
  }
};
// Mutations
const mutations = {
  update_snackbar(state, snackbar_payload) {
    Object.assign(state.snackbar, snackbar_payload);
  },
  set_error(state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
